var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroonusSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173.1 139.3",
    style: {
      enableBackground: "new 0 0 173.1 139.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4176B9;}\n\t.st2{fill:#45B549;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.6,69.7C35.6,83.6,47,95,61,95s25.3-11.3,25.3-25.3c0-0.1,0-0.1,0-0.2h-2.9V68H59.4 c0-8.4,2.1-16.4,5.8-23.3c-1.4-0.2-2.8-0.4-4.3-0.4C47,44.3,35.6,55.7,35.6,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.3,69.7C86.3,83.6,75,95,61,95S35.6,83.6,35.6,69.7S47,44.3,61,44.3c1.5,0,2.9,0.2,4.3,0.4 c4.2-7.9,10.5-14.4,18.1-19c-6.7-3.4-14.3-5.4-22.4-5.4c-27.3,0-49.4,22.1-49.4,49.4S33.7,119,61,119c27.3,0,49.4-22.1,49.4-49.4 c0-0.1,0-0.1,0-0.2h-24C86.3,69.5,86.3,69.6,86.3,69.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.5,69.7c0-14-11.3-25.3-25.3-25.3c-13.9,0-25.3,11.3-25.3,25.2H91v1.8h22.7c0,8.4-2.1,16.4-5.8,23.3 c1.4,0.2,2.8,0.4,4.3,0.4C126.1,95,137.5,83.6,137.5,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.1,20.3c-27.2,0-49.3,22-49.4,49.2h24c0.1-13.9,11.4-25.2,25.3-25.2c14,0,25.3,11.3,25.3,25.3 S126.1,95,112.1,95c-1.5,0-2.9-0.2-4.3-0.4c-4.2,7.9-10.5,14.4-18.1,19c6.7,3.4,14.3,5.4,22.4,5.4c27.3,0,49.4-22.1,49.4-49.4 S139.4,20.3,112.1,20.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroonusSidebarIcon);
export default __webpack_public_path__ + "static/media/croonus-sidebar-icon.934e5c4480dc1012544dc10bee22b8f0.svg";
export { ForwardRef as ReactComponent };